import { render } from "./IconLowestOffer.vue?vue&type=template&id=648f6df9"
const script = {}

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@5.9.3__webpack@5.112.2_esbuild@0.28.2_postcss@8.5.30_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__